// [ / ] cycling for the chart-type strip, gated to the hovered chart panel.
// `controls` is the already-filtered list the SegmentedControl renders, so the
// keyboard order matches exactly what's on screen. Returns the ref to attach to
// the chart-area container.
import { RefObject } from "react";
import { useTabCycle } from "keyboard/useTabCycle";

interface ChartTypeControl<T> {
  value: T;
}

export function useChartTypeKeyboard<T>(
  controls: ChartTypeControl<T>[],
  current: T,
  setCurrent: (value: T) => void,
): RefObject<HTMLDivElement> {
  return useTabCycle<HTMLDivElement>(
    controls.length,
    controls.findIndex((c) => c.value === current),
    (i) => setCurrent(controls[i].value),
    { gated: true },
  );
}
